import Axios from "axios";
import Url from "app/shared/constants/Url";
const FetchEMList = async({search = ""}) => {
    let URL = Url.EmployeeMaster.employeeSearch;
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    const requestParams = {
      auth_key: token,
      user_id: userId,
      
    };
    try {
        const response = await Axios.get(`${URL}?search=${encodeURIComponent(search)}`,{
          params:requestParams,
          headers: {
            'accept': 'application/json' 
          }
        });
        console.log(response,"response")
        if (response.status === 200) {
            return response.data;
          }        
      } catch (error) {
        console.error("Error fetching clients", error.response?.data || error.message);
        throw error;
      } 
};

export default FetchEMList;

// ?page=${encodeURIComponent(page)}&size=${encodeURIComponent(size)}